import { fork } from 'redux-saga/effects';
// 安卓分类
import { watchFetchAClassApps, watchFetchAClassesList } from './acategory';
import {
  watchAAppDetails,
  watchAAppRecommend,
  watchFetchADetailGiftList,
  watchFetchAGroupContent,
  watchFetchAReceiveGift,
} from './adetail';
import { watchFetchRunAndroidSoft } from './anative';
import {
  watchFetchABanner,
  watchFetchAGroupSoft,
  watchFetchAGroupSoftMore,
  watchFetchARecommendSoft,
} from './arecommend';
import {
  watchFetchGetIsSIMInstalled,
  watchFetchGetIsSIMRunning,
  watchFetchGetSIMIsVTEabled,
} from './asimstatus';
// v7.0 卡片
import { watchFetchVideoContent } from './card';
import { watchFetchClassApps, watchFetchClassesList } from './category';
// v7.2我的收藏
import {
  watchFetchAddCollectSpecialorSoft,
  watchFetchDeleteCollectSpecialorSoft,
  watchFetchSoftCollectList,
  watchFetchSpecialCollectList,
} from './collection';
import {
  watchFetchAddComment,
  watchFetchAddCommentCon,
  watchFetchAddScoreForStore,
  watchFetchAddZan,
  watchFetchGetAppList,
  watchFetchGetCommentInfo,
  watchFetchGetCommentList,
  watchFetchGetGrade,
  watchFetchGetUpParams,
  watchFetchGetZtList,
} from './comment';
import {
  watchAppDetails,
  watchAppRecommend,
  watchFetchAppForumRelated,
  watchFetchDetailGiftList,
  watchFetchGroupContent,
  watchFetchReceiveGift,
} from './detail';
import {
  watchDownloadAddSoft,
  watchDownloadAddSoftList,
  watchDownloadCancelSoft,
  watchDownloadGetSoftList,
} from './downloadTask';
// v7.1教育
import {
  watchEducationCategoryGradelist,
  watchEducationCategoryTags,
  watchEducationCollectReport,
  watchEducationDetail,
  watchEducationMineGradeDelete,
  watchEducationMineGradelist,
  watchEducationPay,
  watchEducationPayResult,
  watchEducationPlayDataReport,
  watchEducationPlayUrl,
  watchEducationRecommendBanner,
  watchEducationRecommendGroups,
  watchEducationNewTags,
} from './education';
// v7.2 论坛
import {
  watchForumActionRemove,
  watchForumActionSet,
  watchForumAddComment,
  watchForumAddReview,
  watchForumCommentList,
  watchForumCommentZan,
  watchForumDelete,
  watchForumDetail,
  watchForumDetailMore,
  watchForumLenovoSoft,
  watchForumList,
  watchForumListCol,
  watchForumListPub,
} from './forum';
import {
  watchFetchGameClass,
  watchFetchGameClassApp,
  watchFetchGameRankMoreList,
  watchFetchGameRankTabs,
  watchFetchGameTabs,
  watchGameScrollSave,
  watchGameScrollUse,
  watchFetchGameCategoryTag,
  watchFetchGameExtScreen,
  watchFetchGetSearchTag,
  watchFetchGetGameAppList,
} from './game';
import { watchLogging, watchPostLogInfo } from './log';
import {
  watchFetchDeleteMessageHot,
  watchFetchMessageHot,
  watchFetchMessageList,
  watchMessageZan,
} from './message';
import {
  watchFetchLocalMachineInfo,
  watchFetchLocalSofts,
  watchFetchSilentSoft,
  watchRequestNativeUninstall,
  watchFetchPayGanePayList,
  watchFetchSubscribedList,
} from './native';
import { watchFetchNetBeat } from './network';
import {
  watchBannerContent,
  watchFetchRecoBanner,
  watchFetchRecoRecommend,
  watchGroupContent,
  watchGuessLike,
  watchRecommendContent,
  watchSoftInfos,
  watchSoftInfosByVersion,
  watchWeekHotContent,
  watchFetchRecoOtherTop,
} from './recommend';
import {
  watchFetchCleanSearchRecommend,
  watchFetchFeedbackSuggest,
  watchFetchHotSearchBox,
  watchFetchLenovoWords,
  watchFetchSearchRecommend,
  watchFetchSearchResult,
} from './search';
import {
  watchFetchResetSpecialInfo,
  watchFetchSetSpecialZan,
  watchFetchSpecialListBySource,
  watchFetchSpecialListList,
  watchFetchSpecialListTags,
  watchlFetchSpeciaAppDetails,
  watchSpecialInfo,
} from './special';
import { watchAllRanksAndApps, watchOtherRankApps, watchRankApps } from './topn';
import {
  watchAddTempResidual,
  watchFetchCategoryList,
  watchFetchResidualSoftsDetail,
  watchFetchSoftsDetail,
  watchStopDeleteResidual,
  watchGetAppList,
  watchStopScanResidual,
} from './uninstall';
import { watchGetUserInfo } from './user';
// 用户反馈
import { watchFetchFeedbackQuestionTypes, watchFetchFeedbackRecords } from './userFeedback';
import {
  watchFetchWPAuthorDetail,
  watchFetchWPAuthorList,
  watchFetchWPAuthorShowreel,
  watchFetchWPBannerList,
  watchFetchWPCategoryImgList,
  watchFetchWPCategoryLabels,
  watchFetchWPDetailBanner,
  watchFetchWpOption,
  watchFetchWPRankList,
  watchFetchWPRecoBanner,
  watchFetchWPRecoGroup,
  watchFetchWPRecommendList,
  watchFetchWpScreenListn,
  watchFetchBatchShow,
} from './wallpaper';
import { watchFetchGetWelcomData, watchFetchRecentPopupStrategy } from './welcome';
import { watchFetchWelcomeIdDetail } from './welcomeids';
import { watchFetchGetCustomeSelectPopStatus, watchFetchGetWelcomApp } from './welcomePopUp';
import { watchFetchMallOrders, watchFetchAppsOrders, watchFetchGameOrders } from './order';

// // 探索频道
// import {
//   watchGetDiscoverList,
//   watchGetDiscoverUpdate,
//   watchGetDiscoverUserFeedback,
// } from './discover';

// 大搜索
import {
  watchGetSearchApp,
  watchGetSearchWallpaper,
  watchGetSearchPost,
  watchGetSearchCourse,
  watchGetSearchWallpaperHot,
  watchGetSearchPostHot,
  watchGetSearchCourseHot,
} from './searchResult';

// 壁纸我的页面
import {
  watchFetchWPCollectListPay,
  watchFetchWPSetupListPay,
  watchFetchWPPayListPay,
  watchFetchWPVip,
  watchFetchTurnList,
  watchFetchGroupList,
  watchFetchExchangeResult,
} from './wallpaperPay';

// 9.0.10 aigc
import { watchFetchAiGetReplys, watchFetchAiGetQuestion } from './aigc';
import {
  watchGetDiscountRecommendList,
  watchFetchDiscountRankList,
  watchFetchDiscountRankMenu,
} from './discount';
import { watchFetchGameCdkPolls, watchGameCdkQRcode, watchFetchGameCdkGetDesc } from './gamecdk';

export default function* rootSaga() {
  //下载任务
  yield fork(watchDownloadAddSoft);
  yield fork(watchDownloadAddSoftList);
  yield fork(watchDownloadCancelSoft);
  yield fork(watchDownloadGetSoftList);

  yield fork(watchFetchLocalMachineInfo);
  yield fork(watchFetchLenovoWords);
  yield fork(watchFetchLocalSofts);

  yield fork(watchFetchSearchResult);
  yield fork(watchFetchSearchRecommend);
  yield fork(watchFetchCleanSearchRecommend);

  yield fork(watchRequestNativeUninstall);
  yield fork(watchFetchSilentSoft);
  yield fork(watchFetchGetWelcomApp);
  yield fork(watchFetchGetCustomeSelectPopStatus);
  yield fork(watchFetchPayGanePayList);

  yield fork(watchFetchRecoBanner);
  yield fork(watchFetchRecoRecommend);
  yield fork(watchBannerContent);
  yield fork(watchWeekHotContent);
  yield fork(watchRecommendContent);
  yield fork(watchGroupContent);
  yield fork(watchGuessLike);
  yield fork(watchSoftInfos);
  yield fork(watchSoftInfosByVersion);
  yield fork(watchFetchRecoOtherTop);

  yield fork(watchOtherRankApps);
  yield fork(watchRankApps);
  yield fork(watchAllRanksAndApps);

  yield fork(watchFetchClassApps);
  yield fork(watchFetchClassesList);

  yield fork(watchAppDetails);
  yield fork(watchAppRecommend);

  yield fork(watchFetchNetBeat);

  yield fork(watchFetchWelcomeIdDetail);

  yield fork(watchLogging);
  yield fork(watchPostLogInfo);

  // 安卓 saga监听
  yield fork(watchFetchAClassApps);
  yield fork(watchFetchAClassesList);

  yield fork(watchAAppDetails);
  yield fork(watchAAppRecommend);

  yield fork(watchFetchRunAndroidSoft);

  yield fork(watchFetchGetSIMIsVTEabled);
  yield fork(watchFetchGetIsSIMRunning);
  yield fork(watchFetchGetIsSIMInstalled);

  yield fork(watchFetchABanner);
  yield fork(watchFetchARecommendSoft);
  yield fork(watchFetchAGroupSoft);
  yield fork(watchFetchAGroupSoftMore);

  yield fork(watchFetchGetCommentList);
  yield fork(watchFetchGetGrade);
  yield fork(watchFetchAddComment);
  yield fork(watchFetchAddZan);
  yield fork(watchFetchAddScoreForStore);

  yield fork(watchSpecialInfo);
  yield fork(watchlFetchSpeciaAppDetails);
  yield fork(watchFetchGroupContent);
  yield fork(watchFetchDetailGiftList);
  yield fork(watchFetchReceiveGift);

  yield fork(watchFetchAGroupContent);
  yield fork(watchFetchADetailGiftList);
  yield fork(watchFetchAReceiveGift);

  // 壁纸监听
  yield fork(watchFetchWPDetailBanner);
  yield fork(watchFetchWPRankList);
  yield fork(watchFetchWPRecoBanner);
  yield fork(watchFetchWPRecoGroup);
  yield fork(watchFetchWPBannerList);
  yield fork(watchFetchWPRecommendList);
  yield fork(watchFetchWPCategoryLabels);
  yield fork(watchFetchWPCategoryImgList);
  // yield fork(watchFetchWPCollectList);
  // yield fork(watchFetchWPSetupList);
  // yield fork(watchFetchWPPayList);
  yield fork(watchFetchWpOption);
  yield fork(watchFetchWpScreenListn);
  yield fork(watchFetchWPAuthorList);
  yield fork(watchFetchWPAuthorDetail);
  yield fork(watchFetchWPAuthorShowreel);
  yield fork(watchFetchBatchShow);

  // 我的软件
  yield fork(watchFetchCategoryList);
  yield fork(watchFetchSoftsDetail);
  // 专题 列表页面
  yield fork(watchFetchSpecialListTags);
  yield fork(watchFetchSpecialListList);
  yield fork(watchFetchSpecialListBySource);
  yield fork(watchFetchResetSpecialInfo);

  yield fork(watchStopScanResidual);
  yield fork(watchAddTempResidual);
  yield fork(watchStopDeleteResidual);
  yield fork(watchGetAppList);
  yield fork(watchFetchResidualSoftsDetail);

  // 搜索反馈
  yield fork(watchFetchFeedbackSuggest);

  // 欢迎页
  yield fork(watchFetchGetWelcomData);
  yield fork(watchFetchRecentPopupStrategy);

  // 游戏页
  yield fork(watchGameScrollSave);
  yield fork(watchGameScrollUse);

  // 用户反馈
  yield fork(watchFetchFeedbackRecords);
  yield fork(watchFetchFeedbackQuestionTypes);
  yield fork(watchFetchSetSpecialZan);

  // v7.0 卡片

  yield fork(watchFetchVideoContent);

  // v7.1 教育
  yield fork(watchEducationRecommendBanner);
  yield fork(watchEducationRecommendGroups);
  yield fork(watchEducationCategoryTags);
  yield fork(watchEducationNewTags);
  yield fork(watchEducationCategoryGradelist);
  yield fork(watchEducationMineGradelist);
  yield fork(watchEducationMineGradeDelete);
  yield fork(watchEducationDetail);
  yield fork(watchEducationPlayUrl);
  yield fork(watchEducationPlayDataReport);
  yield fork(watchEducationCollectReport);
  yield fork(watchEducationPay);
  yield fork(watchEducationPayResult);

  // v7.2 我的收藏
  yield fork(watchFetchSoftCollectList);
  yield fork(watchFetchAddCollectSpecialorSoft);
  yield fork(watchFetchDeleteCollectSpecialorSoft);
  yield fork(watchFetchSpecialCollectList);

  // v7.2 论坛
  yield fork(watchForumList);
  yield fork(watchForumListPub);
  yield fork(watchForumListCol);
  yield fork(watchForumLenovoSoft);
  yield fork(watchForumDetail);
  yield fork(watchForumDetailMore);
  yield fork(watchForumAddComment);
  yield fork(watchForumAddReview);
  yield fork(watchForumCommentList);
  yield fork(watchForumCommentZan);
  yield fork(watchForumActionSet);
  yield fork(watchForumActionRemove);
  yield fork(watchForumDelete);

  // v7.4
  yield fork(watchFetchHotSearchBox);
  yield fork(watchFetchAppForumRelated);
  yield fork(watchFetchMessageHot);
  yield fork(watchFetchDeleteMessageHot);
  yield fork(watchFetchMessageList);
  yield fork(watchMessageZan);

  //v7.5
  yield fork(watchFetchGameTabs);
  yield fork(watchFetchGameClassApp);
  yield fork(watchFetchGameClass);
  yield fork(watchFetchGameRankTabs);
  yield fork(watchFetchGameRankMoreList);
  // 8.6游戏
  yield fork(watchFetchGameCategoryTag);
  yield fork(watchFetchGameExtScreen);
  yield fork(watchFetchGetSearchTag);
  yield fork(watchFetchGetGameAppList);

  //v8.0
  yield fork(watchFetchGetAppList);
  yield fork(watchFetchGetZtList);
  yield fork(watchFetchGetUpParams);
  yield fork(watchFetchGetCommentInfo);
  yield fork(watchFetchAddCommentCon);
  // 8.0
  yield fork(watchGetUserInfo);

  // 8.2
  yield fork(watchFetchMallOrders);
  yield fork(watchFetchAppsOrders);
  yield fork(watchFetchGameOrders);
  // // 探索频道
  // yield fork(watchGetDiscoverList);
  // yield fork(watchGetDiscoverUpdate);
  // yield fork(watchGetDiscoverUserFeedback);

  // 8.3 大搜索
  yield fork(watchGetSearchApp);
  yield fork(watchGetSearchWallpaper);
  yield fork(watchGetSearchPost);
  yield fork(watchGetSearchCourse);
  yield fork(watchGetSearchWallpaperHot);
  yield fork(watchGetSearchPostHot);
  yield fork(watchGetSearchCourseHot);

  // 8.5壁纸
  yield fork(watchFetchWPPayListPay);
  yield fork(watchFetchWPCollectListPay);
  yield fork(watchFetchWPSetupListPay);
  yield fork(watchFetchWPVip);
  yield fork(watchFetchTurnList);
  yield fork(watchFetchGroupList);

  yield fork(watchFetchSubscribedList);

  // 9.0 壁纸兑换
  yield fork(watchFetchExchangeResult);

  // 9.0.10 aigc
  yield fork(watchFetchAiGetReplys);
  yield fork(watchFetchAiGetQuestion);

  yield fork(watchGetDiscountRecommendList);
  yield fork(watchFetchDiscountRankList);
  yield fork(watchFetchDiscountRankMenu);
  // 游戏CDK
  yield fork(watchFetchGameCdkPolls);
  yield fork(watchGameCdkQRcode);
  yield fork(watchFetchGameCdkGetDesc);
}
